import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {tagsSelector} from "../../ducks/product";
import Button from "../../../common/Button";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";

import styles from "./tags.module.scss";

function Tags(props) {
  const {tags} = props;
  return tags && tags.length ? (
    <div className={styles.root}>
      {tags.map(({name, path}) => (
        <div key={name} className={styles.tag}>
          <Button size="small" variant="outlined" style="secondary" href={path}>
            {name}
          </Button>
        </div>
      ))}
    </div>
  ) : null;
}

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string
    })
  )
};

export default connect((state) => ({
  tags: tagsSelector(state)
}))(withErrorBoundary(Tags));
